export const agedReceivablesMapping = (item: any) => ({
  CustomerCompanyName: item.customerCompanyName,
  NotYetOverdue: item.notYetOverdue,
  NotYetOverdueInvoiceCount: item.notYetOverdueInvoiceCount,
  ThirtyOrLess: item.thirtyOrLess,
  ThirtyOrLessInvoiceCount: item.thirtyOrLessInvoiceCount,
  ThirtyOneToSixty: item.thirtyOneToSixty,
  ThirtyOneToSixtyInvoiceCount: item.thirtyOneToSixtyInvoiceCount,
  SixtyOneToNinety: item.sixtyOneToNinety,
  SixtyOneToNinetyInvoiceCount: item.sixtyOneToNinetyInvoiceCount,
  NinetyOneOrMore: item.ninetyOneOrMore,
  NinetyOneOrMoreInvoiceCount: item.ninetyOneOrMoreInvoiceCount,
  TotalUnpaid: item.totalUnpaid,
  CompanyName: item.CompanyID,
});
